export const LAST_COMPANY = 'lastCompany'
export const DASHBOARD_PROJECTS_SORT = 'dashboardProjectsSort'
export const DASHBOARD_THREADS_SORT = 'dashboardThreadsSort'
export const EDITOR_BACKGROUND_COLOR = 'editorBackgroundColor'
export const EDITOR_ACCENT_COLOR = 'editorAccentColor'
export const EDITOR_DIVIDER_FILL_MODE = 'editorDividerFillMode'
export const EDITOR_COMMENTS_SHOW = 'editorCommentsShow'
export const EDITOR_TASKS_SHOW = 'editorTasksShow'
export const EDITOR_NAV_WIDTH_PRO_MODE = 'editorNavWidthProMode'
export const EDITOR_ASK_V2 = 'editorAskV2'
export const EDITOR_GRID_COLOR = 'editorGridColor'
export const EDITOR_FLEX_COLOR = 'editorFlexColor'
export const EDITOR_ABSOLUTE_COLOR = 'editorAbsoluteColor'
export const EDITOR_SHOW_GRID = 'editorShowGrid'
